import { Component, Input } from '@angular/core';

import { UICallLogEvent } from '../../models/call-history.model';

@Component({
  selector: 'app-voicemail',
  templateUrl: './voicemail.component.html',
  styleUrls: ['./voicemail.component.scss'],
})
export class VoicemailComponent {
  @Input() callItem: UICallLogEvent;

  public openLink(link: string): void {
    window.open(link, '_blank');
  }
}
